import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.21 19c-.02.392-.068.67-.176.908-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.905 1.905 0 01-.778-.874C3 19.48 3 18.92 3 17.8V6.2c0-1.12 0-1.68.194-2.108.17-.376.443-.682.778-.874C4.35 3 4.85 3 5.847 3h.534c.996 0 1.495 0 1.875.218.335.192.607.498.778.874.108.238.156.516.177.908m5.578 14c.021.392.07.67.177.908.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.194-2.108a1.904 1.904 0 00-.778-.874C19.65 3 19.15 3 18.153 3h-.534c-.996 0-1.495 0-1.875.218a1.904 1.904 0 00-.778.874c-.108.238-.156.516-.177.908M10 12L7 9m3 3l-3 3m3-3H3m11 0l3-3m-3 3l3 3m-3-3h7"
    })
  ]))
}